<template>
  <div class="top-performer" data-qa-id="blur-top-performer-wrapper">
    <div class="top-performer__header">
      <h2 class="mt-e-title mt-e-title--header">
        {{ $t('pages.dashboard.components.top_performing_families.title') }}
      </h2>
    </div>
    <div
      v-for="topPerformer in topPerformers"
      :key="topPerformer.familyName"
      data-qa-id="top-performer-list"
      class="top-performer__list"
    >
      <span
        data-qa-id="promotion-title"
        class="top-performer__list__name is-blur is-blur--less"
      >{{ topPerformer.familyName }}</span>
      <div class="top-performer__list__right-part is-blur is-blur--less">
        <span class="top-performer__list--orders">
          {{
            $t('pages.dashboard.components.top_performing_families.order_quantity', { orderQuantity: topPerformer.orderQuantity })
          }}</span>
        <span class="top-performer__list--amount">
          <strong>
            {{ topPerformer.saleAmount }}
          </strong>
        </span>
      </div>
      <span
        class="top-performer__list__bar"
        :style="{width: topPerformer.width}"
      />
    </div>
  </div>
</template>
<script src="./script.js" />
